module.exports = __webpack_public_path__ + "static/media/whitelogo.b3c9348b.png";